import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login/login.service';
import { RiesgoService } from 'app/services/riesgo/riesgo.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-nuevo-sector',
  templateUrl: './nuevo-sector.component.html',
  styleUrls: ['./nuevo-sector.component.scss']
})
export class NuevoSectorComponent implements OnInit {

  @Output() cerrarAgregarSector: EventEmitter<boolean> = new EventEmitter();
  @Output() refresh = new EventEmitter<boolean>();
  loading: boolean = false;
  editar: boolean;
  formularioSector: FormGroup;
  Titulo:any
  user:any;
  constructor(private riesgo:RiesgoService, private loginService:LoginService, private router:Router) {
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.formularioSector = new FormGroup({
      "Nombre_Sector" :new FormControl("",Validators.required),
      "Codigo_Sector":new FormControl("",Validators.required),
      "Usuario":new FormControl(this.user.Usuario),
      "Estado":new FormControl(""),
    });
   }

  ngOnInit() {
    this.Titulo= "Crear Sector";
    if(this.riesgo.dataSector != "" && this.riesgo.dataSector != undefined){
      this.Titulo= "Editar Sector";
      this.editar = true;
      let nombre : any = this.riesgo.dataSector.Nombre_Sector;
      this.formularioSector.controls['Nombre_Sector'].setValue(nombre);  
        this.formularioSector.controls['Codigo_Sector'].setValue(this.riesgo.dataSector.Codigo_Sector);   
    }else{
      this.editar = false;
    }
  }

  crearSector(){
      this.loading = true
      this.riesgo.CrearSector(this.formularioSector.getRawValue()).subscribe(
        res=>{
          this.loading = false;
          Swal.fire({
            title: "¡Éxito!",
            text: 'Sector guardado correctamente.',
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then( resp1 => {
            if (resp1.value == true){              
              this.loginService.clickGuard = true;
                this.refresh.emit();
                this.cerrarAgregarSector.emit();
            }
          }) 
        }
      )
    
    
  }

  editarSector(){
    this.loading = true
    this.formularioSector.controls['Estado'].setValue("A");  
    this.riesgo.ActualizarSector(this.formularioSector.getRawValue(),this.riesgo.dataSector.idSector).subscribe(
      res=>{
        this.loading = false;
        Swal.fire({
          title: "¡Éxito!",
          text: 'Sector actualizado correctamente',
          type: "success",
          allowOutsideClick: false,
          heightAuto: false
        }).then( resp => {
          if (resp.value == true){              
            this.loginService.clickGuard = true;
              this.refresh.emit();
              this.cerrarAgregarSector.emit();
          }
        }) 
      }
    )
  }

  

  CerrarPopUp(){
    this.cerrarAgregarSector.emit();
  }
  back(){
    this.loginService.clickGuard = true;
    this.router.navigate(['/riesgo/Configuracion-riesgos/listado']);
  }

}
